import React from 'react';
import PageLayout from '../../layouts/pagelayout';
import BreadCrumb from '../../components/breadcrumb';
import BusinessSustainability from '../../layouts/managing-our-business-sustainability/business-sustainability';
import FirmFoundationLastingValue from '../../layouts/managing-our-business-sustainability/firm-foundation-lasting-value';
import CommunityBeneficiaries from '../../content/managing-our-business-sustainability/community-beneficiaries';
import FirmFoundationOurBoard from '../../layouts/managing-our-business-sustainability/firm-foundation-our-board';

const ManagingOurBusinessSustainability = () => {
  return (
    <PageLayout
      pageTitle="Vedanta - Managing Our Business Sustainability"
      pageLink="/sustainability-and-esg/managing-our-business-sustainability"
    >
      <div className="managing-our-business-sustainability">
        <BreadCrumb />
        <BusinessSustainability />
        <FirmFoundationLastingValue />
        <FirmFoundationOurBoard />
      </div>
    </PageLayout>
  );
};

export default ManagingOurBusinessSustainability;
